import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from "../../../../adapter-vue";
import {
  TUIStore,
  StoreName,
  IMessageModel,
  IConversationModel,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import doubleArrowIcon from "../../../../assets/icon/double-arrow.svg";

interface IEmits {
  (key: "scrollToLatestMessage"): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["scrollToLatestMessage"],
  setup(__props, { expose, emit: emits }: { emit: ({
  (key: "scrollToLatestMessage"): void;
}), expose: any, slots: any, attrs: any }) {



const messageList = ref<IMessageModel[]>([]);
const currentLastMessageTime = ref<number>(0);
const isScrollOverOneScreen = ref<boolean>(false);

onMounted(() => {
  TUIStore.watch(StoreName.CHAT, {
    messageList: onMessageListUpdated,
  });

  TUIStore.watch(StoreName.CONV, {
    currentConversation: getLatestMessageTime,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CHAT, {
    messageList: onMessageListUpdated,
  });

  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: getLatestMessageTime,
  });
});

// TODO
const isExistLatestMessage = computed((): boolean => {
  const lastSuccessMessageIndex = messageList.value?.findLastIndex(
    (message: IMessageModel) => message.status === "success"
  );
  return (
    lastSuccessMessageIndex &&
    messageList?.value[lastSuccessMessageIndex]?.time < currentLastMessageTime?.value
  );
});

function onMessageListUpdated(newMessageList: IMessageModel[]) {
  messageList.value = newMessageList || [];
}

function getLatestMessageTime(conversation: IConversationModel | undefined) {
  currentLastMessageTime.value = conversation?.lastMessage?.lastTime || 0;
}

// 消息列表向上的滚动高度大于一屏时，展示滚动到最新
function judgeScrollOverOneScreen(e: Event) {
  if (typeof (e.target as HTMLElement)?.scrollTop === "number") {
    const scrollListDom = e.target as HTMLElement;
    const { height } = scrollListDom.getBoundingClientRect() || {};
    const { scrollHeight, scrollTop } = scrollListDom;
    if (height && scrollHeight) {
      if (scrollTop < scrollHeight - 2 * height) {
        isScrollOverOneScreen.value = true;
      } else {
        isScrollOverOneScreen.value = false;
      }
    }
  }
}

// 载入最新的 messageSource
function resetMessageSource() {
  if (TUIStore.getData(StoreName.CHAT, "messageSource") !== undefined) {
    TUIStore.update(StoreName.CHAT, "messageSource", undefined);
  }
}

// 滚动到消息列表最底部
function scrollToMessageListBottom() {
  resetMessageSource();
  setTimeout(() => emits("scrollToLatestMessage"), 100);
}

expose({
  judgeScrollOverOneScreen,
});

return { __sfc: true,emits, messageList, currentLastMessageTime, isScrollOverOneScreen, isExistLatestMessage, onMessageListUpdated, getLatestMessageTime, judgeScrollOverOneScreen, resetMessageSource, scrollToMessageListBottom, TUITranslateService, Icon, doubleArrowIcon }
}

})